// extracted by mini-css-extract-plugin
module.exports = {"atom__wave-divider-container":"styles_atom__wave-divider-container__C3u8Y","wave":"styles_wave__dPsoq","wave--small":"styles_wave--small__IPzng","fill":"styles_fill__K2RTh"};